import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/app/App';
import { initScrollbarAutoHide } from '@/lib/scrollbar';
import '@/styles/index.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element #root was not found in index.html.');
}

// Overlay-style scrollbars: the thumb appears while scrolling, then fades.
initScrollbarAutoHide();

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
